import { local, session } from './InMemoryStorage';

/* istanbul ignore next */
function storageAvailable(type) {
  try {
    var storage = global[type],
      x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
    );
  }
}

export default class StorageHelper {
  sessionStorage;
  localStorage;

  constructor() {
    /* istanbul ignore next */
    this.sessionStorage = storageAvailable('sessionStorage')
      ? global.sessionStorage
      : session;

    /* istanbul ignore next */
    this.localStorage = storageAvailable('localStorage')
      ? global.localStorage
      : local;
  }

  get storage() {
    return this.localStorage;
  }

  setItem(key, value) {
    return this.storage.setItem(key, value);
  }

  getItem(key) {
    return this.storage.getItem(key);
  }

  removeItem(key) {
    return this.storage.removeItem(key);
  }

  clear() {
    return this.storage.clear();
  }
}

export { storageAvailable };



// WEBPACK FOOTER //
// ./src/utils/StorageHelper.js